import { Button, Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";
import memberPreview from "./members-preview.png";
import insightsPreview from "./insights-preview.png";

const displayImage = (name: String | undefined) => {
  switch (name) {
    case "members-preview":
      return memberPreview;
    case "insights-preview":
      return insightsPreview;

    default:
      return "";
  }
};
type Props = {
  visible?: boolean;
  title?: string;
  showFreePagesMsg?: boolean;
  imagePreview?: "insights-preview" | "members-preview";
};
/**
 * This component check if trail is ended and user is not paid, show a popup to block whole view
 */
export default function TrialEndModal({
  visible = true,
  title = "Your trial has expired 😞",
  showFreePagesMsg = true,
  imagePreview,
}: Props) {
  const navigate = useNavigate();

  return (
    <>
      <Modal
        title={title}
        visible={visible}
        footer={null}
        onCancel={() => {
          navigate("/home");
        }}
        style={{ minWidth: "750px", top: "7%" }}
      >
        <div className="flex items-center justify-center flex-col">
          {Boolean(displayImage(imagePreview)) && (
            <img
              src={displayImage(imagePreview)}
              alt="page preview"
              style={{ width: "500px", border: "solid #7f7f7f 1px" }}
              className="mb-4 rounded-md"
            />
          )}
          <p className="text-center">
            Please{" "}
            <a
              href="https://discord.gg/WJFTPtvGGw"
              target="_blank"
              rel="noreferrer"
            >
              contact
            </a>{" "}
            us if you want a trial of this!
          </p>
          {showFreePagesMsg && (
            <p className="text-center">
              On free tier you currently have access to:
              <Link to="/home" className="text-dots-vibrant-orange">
                {" "}
                Home
              </Link>
              ,
              <Link to="/automation" className="text-dots-vibrant-orange">
                {" "}
                Automation
              </Link>{" "}
              and
              <Link to="/settings" className="text-dots-vibrant-orange">
                {" "}
                Settings
              </Link>
            </p>
          )}
          <Button
            type="primary"
            className="mb-8 mt-2"
            size="large"
            shape="round"
            href="/settings"
          >
            Click here to upgrade
          </Button>
        </div>
      </Modal>
    </>
  );
}
